import React, {memo, useMemo} from "react"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SubMenuComponent} from "../../../../components/SubMenu"
import {useLocalization} from "../../../../hooks/localization"
import iconLogs from "../../../../assets/images/icons/settings/log.png"

export const AdvancedMenu = memo(function AdvancedMenu() {
    const {t} = useLocalization()
    const CustomMenuRouters = useMemo(
        () => [
            {
                icon: iconLogs,
                name: t("supervisor_config"),
                path: "/settings/advanced-settings/supervisor-config"
            },
            {
                icon: iconLogs,
                name: t("worker_config"),
                path: "/settings/advanced-settings/worker-config"
            },
            {
                icon: iconLogs,
                name: t("test"),
                path: "/settings/advanced-settings/test"
            },
            {
                icon: iconLogs,
                name: t("panel_settings"),
                path: "/settings/advanced-settings/panel-settings"
            }
        ],
        [t]
    )
    return (
        <PasswordContainer requiredRole="default" isFullscreen={true}>
            <SettingsPageContainer buttons={[]} className="service-edit" backUrl={"/settings"} style={null}>
                <div className="content-divider">
                    {CustomMenuRouters.map((control, index) => (
                        <SubMenuComponent key={index} icon={control.icon} name={control.name} path={control.path} />
                    ))}
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
